<template>
  <Breadcrumbs
      title="Issue New Trust"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Trust Management', path: '/issue-trust' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <issueTrustForm/>
    </div>
  </div>
</template>

<script>

import issueTrustForm from "@/pages/master_data/trust_management/issueTrustForm.vue";

export default {
  components: {
    issueTrustForm
  }
}

</script>